<template>
    <div class="gallery">
        <h3>{{title}}</h3>
        <div class="previews columns is-mobile is-multiline">
            <div v-for="(pic, index) in imgs" :key="pic.src" class="column">
                <img :src="pic.src" :alt="pic.alt" v-on:click="activePicIndex=index">
            </div>
            <div class="modal" v-bind:class="{'is-active': activePicIndex!=null}">
                <div class="modal-background" v-on:click="activePicIndex=null"></div>
                <div class="icon left" v-on:click="activePicIndex=(imgs.length+activePicIndex-1)%imgs.length;"><img src="@/assets/icons/arrow-left-bold-circle.png"></div>
                <div class="icon right" v-on:click="activePicIndex=(imgs.length+activePicIndex+1)%imgs.length;"><img src="@/assets/icons/arrow-right-bold-circle.png"></div>
                <div class="modal-content" v-if="activePicIndex !=null">
                    <p class="counter">{{activePicIndex+1}}/{{imgs.length}}</p>
                    <div class="image">
                        <img :src="imgs[activePicIndex].src">
                    </div>
                    <p class="caption">{{imgs[activePicIndex].title}}</p>
                    <p class="creditline">Bild: {{imgs[activePicIndex].creditline}}</p>
                </div>
                <button class="modal-close is-large" aria-label="close" v-on:click="activePicIndex=null"></button>
            </div>
        </div>
        <div class="footer">
            <span class="byline">dpa &#9679; infocom</span>
        </div>
    </div>
</template>

<script>
export default{
    name: "dnl-gallery",
    props: {
        imgs: Array,
        title: String
    },
    data: function(){
        return {
            activePicIndex: null
        }
    },
    mounted: function(){
        window.addEventListener('keydown', (e) => {
            if(e.key == "ArrowRight" && this.activePicIndex != null){
                this.activePicIndex = (this.imgs.length+this.activePicIndex+1)%this.imgs.length;
            }else if(e.key == "ArrowLeft"){
                this.activePicIndex = (this.imgs.length+this.activePicIndex-1)%this.imgs.length;
            }
        })
    }
}
</script>

<style>
.gallery{
    border-top: 4px solid #E2E3E4;
    padding-top: 5px;
    padding-bottom: 30px;
}

.previews{
    flex-flow: row;
    flex-wrap: wrap;
    justify-content: center;
    max-width: 100%;
}

.previews img{
    cursor: pointer;
    height: 100px;
    max-height: 90vh;
    padding: 5px;
    width: auto !important;
}

.modal-content{
    max-width: 1000px;
    width: 100%
}

.modal-content .image{
    height: calc(100% - 140px);
    margin: 0 auto;
    overflow: hidden;
}

.modal-content img{
    height: auto;
    margin: 0 auto;
    max-height: 100%;
}

.modal .icon, .icon img{
    height: 60px;
    width: 60px;
    z-index: 10
}

.modal .icon.left{
    left: 30px;
    position: absolute;
}

.modal .icon.right{
    right: 30px;
    position: absolute;
}

.caption, .creditline{
    color: #FFF;
}

.caption{
    margin: 0 10px 0 0 !important;
    max-width: 90%;
}

.creditline{
    font-size: 0.7em;
    text-align: right;
}

.gallery .counter{
    color: #FFF;
    text-align: center;
}

.gallery .footer{
    background: #e2e3e4;
    padding: 5px 10px;
}

.gallery .footer span{
    color: #000;
    font-size: 11px;
    font-style: initial;
    font-weight: 700;
}

.column{
    flex-grow: 0 !important;
    flex-shrink: 0 !important;
    min-width: fit-content !important;
    padding: .3rem !important;
}

h3 {
    font-size: 20px;
    font-weight: 700;
}

@media screen and (min-width: 769px){
    .modal-content{
        width: 100% !important;
    }
}

@media (max-width: 768px){
    .modal .icon{
        bottom: 10px;
    }
    
    .modal-content{
        max-width: 95vw;
    }

    .caption{
        margin: 0 auto !important;
    }

    .creditline{
        margin-right: 10px;
    }

    .previews{
        margin: 10px 0;
    }

    .previews img{
        padding: 2px;
    }
}
</style>